import api from "services/api";

// Ajusta si tu backend usa otro path (p.ej. "/awards" o "/reconocimientos")
const ENDPOINT = "/award";

export async function listReconocimientos() {
  const { data } = await api.get(ENDPOINT);
  // Tu API suele responder { total, page:[...] }
  return Array.isArray(data) ? data : data?.page ?? data?.data ?? [];
}

export async function getReconocimientoById(id) {
  const { data } = await api.get(`${ENDPOINT}/${encodeURIComponent(id)}`);
  return data?.data ?? data ?? {};
}

export async function createReconocimiento(payload) {
  const { data } = await api.post(ENDPOINT, payload, {
    headers: { "Content-Type": "application/json" },
  });
  return data?.data ?? data;
}

export async function updateReconocimiento(id, payload, method = "PATCH") {
  const { data } = await api.put(`${ENDPOINT}/${encodeURIComponent(id)}`, payload, {
    headers: { "Content-Type": "application/json" },
  });
  return data?.data ?? data;
}

export async function deleteReconocimiento(id) {
  const { data } = await api.delete(`${ENDPOINT}/${encodeURIComponent(id)}`);
  return data?.data ?? data;
}